export default "__VITE_ASSET__DAqWR69b__"